export const MODULE_NAME = 'axp-travel-home';

export const ADVISORY_MODULE_NAME = 'axp-travel-advisory';
export const CREDIT_MODULE_NAME = 'axp-travel-credit';
export const FOOTER_MODULE_NAME = 'axp-travel-footer-links';
export const LEGAL_MODULE_NAME = 'axp-travel-agent-legal';
export const MARKETING_MODULE_NAME = 'axp-personalized-marketing';
export const MR_MODULE_NAME = 'axp-travel-multiple-rewards';
export const NAV_MODULE_NAME = 'axp-travel-navigation';
export const ROOT_MODULE_NAME = 'axp-consumer-travel-root';
export const SEARCH_MODULE_NAME = 'axp-travel-home-search';
export const TERMS_MODULE_NAME = 'axp-travel-terms-and-conditions';
export const UNUSED_TICKETS_MODULE_NAME = 'axp-travel-unused-tickets';
